/* eslint-disable import/prefer-default-export */
import SnackbarPC from '@tencent/dui/lib/components/Snackbar';
import SnackbarMobile from '@tencent/dui-mobile/lib/components/Snackbar';

import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { ADDON_LINK,
    ADDON_ICON_LINK,
    EDITABLE,
    ELEMENT_LINK,
    EDITABLE_FULLSCREEN,
    NO_COPY,
    NO_COPY_FULLSCREEN,
    NO_COPY_LINK,
    NORMAL_LINK,
    ONLY_VIEW,
    ONLY_VIEW_FULLSCREEN,
    ONLY_VIEW_LINK,
    ADDON,
} from './config';
import i18n from '@i18next/i18n';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { EMAIL_PREFIX } from '@src/slide/domain/ui-model/element-modeles/property/link/constant/prefix';
import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

// 通过iconMode值，确认链接样式选项的选中状态，放进 config 里
const getNormalLinkConfig = (normalConfig, linkData) => normalConfig.map((button) => {
    if (button.id === 'changeDisplay') {
        button.config.items?.forEach((item) => {
            item.isSelected = item.id === 'icon' ? !!linkData.iconMode : !linkData.iconMode;
        });
        return button;
    }
    return button;
});

export const getIframeToolBarConfig = (editState, needFullscreen, needShowAddon, addonHandler, addon) => {
    let importConfig;
    // 如果为卡片态插件
    if (editState === PPTEditorStateType.COPYABLE) {
        // 如果只能复制元素
        importConfig = needFullscreen ? ONLY_VIEW_FULLSCREEN : ONLY_VIEW;
    } else if (editState === PPTEditorStateType.SELECTABLE) {
        importConfig = needFullscreen ? NO_COPY_FULLSCREEN : NO_COPY;
    } else {
        importConfig = needFullscreen ? EDITABLE_FULLSCREEN : EDITABLE;
        if (needShowAddon) {
            const {
                addonSceneItemsMap,
                formatAddonSceneList,
                addonScenes,
            } = addonHandler;
            (ADDON[1].config as any).items = formatAddonSceneList(addonSceneItemsMap.get(addonScenes.IFRAME), true);
            const changeModeIndex = importConfig.findIndex(item => item.id === 'changeDisplay');
            importConfig = importConfig.slice(0, changeModeIndex + 1).concat(ADDON)
                .concat(importConfig.slice(changeModeIndex + 1));
        }
    }
    return importConfig;
};

export const geIframeLinkToolBarConfig = (editState, linkData) => {
    let importConfig;
    // 如果为链接态插件，并且是process on
    if (editState === PPTEditorStateType.COPYABLE) {
        // 如果只能复制元素
        importConfig = ONLY_VIEW_LINK;
    } else if (editState === PPTEditorStateType.SELECTABLE) {
        importConfig = NO_COPY_LINK;
    } else if (linkData.iconMode) {
        importConfig = ADDON_ICON_LINK;
    } else {
        importConfig = ADDON_LINK;
    }
    return importConfig;
};

export const handleCopyUrl = (href) => {
    if (!SlideDataServices.PrivilegeManager()?.copyable) return;
    eventBus.emit(EventKeys.TRIGGER_COPY_EVENT, (triggerCopyEvent) => {
        triggerCopyEvent(href);
        const msg: any = {
            message: i18n.t('复制链接成功'),
            type: 'success',
            autoClose: true,
        };
        if (browser.isMobile) {
            SnackbarMobile.show(msg);
        } else {
            SnackbarPC.show(msg);
        }
    });
};

export const getDisplayPrivilege = (opt) => {
    const { addon, editState, linkData, isIframeLink, needFullscreen, needShowAddon,
        addonHandler } = opt || {};
    // 默认为普通链接
    let importConfig;
    // 判断是否为插件
    const addonDisplayMode = addon?.displayMode;
    if (browser.isMobile) {
        if (addonDisplayMode === AddonMode.IFRAME) {
            return null;
        }
        return NO_COPY_LINK;
    }
    if (addonDisplayMode === AddonMode.IFRAME) {
        importConfig = getIframeToolBarConfig(editState, needFullscreen, needShowAddon, addonHandler, addon);
    } else if (isIframeLink) {
        importConfig = geIframeLinkToolBarConfig(editState, linkData);
    } else {
        // 为普通链接
        if (editState > PPTEditorStateType.EDITABLE) {
            // 非编辑态，不显示工具栏
            importConfig = NO_COPY_LINK;
        } else if (opt.isElemLink) {
            importConfig = ELEMENT_LINK;
        } else {
            importConfig = getNormalLinkConfig(NORMAL_LINK, linkData);
        }
    }
    return importConfig; // 存在dropDown配置时获取的是const的副本
};

export const getTipShowText = (isText, isChinese, isEmail, config) => {
    let tipTextShow = config.tipText;
    if (isText && isChinese) {
        tipTextShow = i18n.t('链接到幻灯片');
    } else if (isText && isEmail) {
        tipTextShow = i18n.t('发邮箱至');
    }
    return tipTextShow;
};

export const getIsText = (text, isChinese, isEmail) => text && (isChinese || isEmail);

export const getIsEmail = href => href?.indexOf(EMAIL_PREFIX) === 0;

export const tdwOnSelectedItemCallback = (mode, addon) => {
    tdw({
        opername: TDWOperationType.DOC_ADDON_PLATFORM,
        module: TDWModuleType.ADDON_IFRAME,
        action: TDWActionType.ADDON_INSERT_STYLE,
        ver5: mode === AddonMode.IFRAME ? 1 : 3,
        ver6: addon?.iframeId,
    });
};

export const handleTdwReport = (id, addon, isIframeLink = false) => {
    if ((addon && addon.displayMode === AddonMode.IFRAME) || isIframeLink) {
        const { iframeId, embedUrl } = addon;
        tdw({
            opername: TDWOperationType.DOC_ADDON_PLATFORM,
            module: TDWModuleType.ADDON_INSERT_TOOLBAR,
            action: id,
            ver6: iframeId,
            ver10: new URL(embedUrl).host,
        });
    }
};
